import * as React from "react";
import { getPlayerRootModelName, getLocalPlayerClientIdxOrThrow, hasLocalPlayerClientIdx } from "@modules/player";
import { HIGHLIGHT_TIMEOUT_MS } from "../modelTreeUtils";
export function ModelTreeView({ node, depth, onToggle, onSelect, selectedUID, autoUpdate, search, onContextMenu }) {
    if (node === undefined)
        return React.createElement("div", { className: "model-properties-empty" }, "No Models");
    const hasChildren = node.childNodes.length > 0;
    const age = node.changedAt !== undefined ? Date.now() - node.changedAt : Infinity;
    let className = "model-node";
    if (node.changeType !== undefined && (!autoUpdate || age < HIGHLIGHT_TIMEOUT_MS)) {
        className += ` ${node.changeType}`;
    }
    if (node.uid === selectedUID) {
        className += " selected";
    }
    const isLocalPlayerRoot = hasLocalPlayerClientIdx() && node.name === getPlayerRootModelName(getLocalPlayerClientIdxOrThrow());
    const displayName = isLocalPlayerRoot ? `${node.name} ★` : node.name;
    const searchLower = search.toLowerCase();
    const highlight = (text) => {
        if (!searchLower)
            return text;
        const lower = text.toLowerCase();
        const index = lower.indexOf(searchLower);
        if (index === -1)
            return text;
        return (React.createElement(React.Fragment, null,
            text.slice(0, index),
            React.createElement("span", { className: "model-node-highlight" }, text.slice(index, index + search.length)),
            text.slice(index + search.length)));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: className, style: { paddingLeft: depth * 16 }, onClick: () => {
                onSelect(node.uid);
                if (hasChildren) {
                    onToggle(node.uid);
                }
            }, onContextMenu: (event) => {
                event.preventDefault();
                event.stopPropagation();
                onContextMenu(node.uid, event.clientX, event.clientY);
            } },
            hasChildren ? React.createElement("span", { className: "model-node-arrow" }, node.expanded ? "▼" : "▶") : React.createElement("span", { className: "model-node-arrow" }, " "),
            React.createElement("span", { className: "model-node-name" }, highlight(displayName))),
        node.expanded &&
            node.childNodes.map((c) => (React.createElement(ModelTreeView, { key: c.uid, node: c, depth: depth + 1, onToggle: onToggle, onSelect: onSelect, selectedUID: selectedUID, autoUpdate: autoUpdate, search: search, onContextMenu: onContextMenu })))));
}
